<template>
  <div class="scores-container">
    <div class="risk-score-card">
      <i class="fa fa-chart-pie risk-icon"></i> Dividend Tracker
    </div>
  <div class="dividend-tracker">


    <div v-if="showDividendForm" class="add-dividend-form">
      <h3>{{ isEditingDividend ? 'Edit Dividend Holding' : 'Add New Dividend Holding' }}</h3>
      <input type="text" v-model="editableDividend.div_symbol" placeholder="Symbol">
      <input type="number" v-model="editableDividend.quantity" placeholder="Quantity">
      <input type="number" v-model="editableDividend.dividend_amount" placeholder="Dividend Per Share">
      <input type="date" v-model="editableDividend.ex_dividend_date" placeholder="Ex-Dividend Date">
      <input type="date" v-model="editableDividend.payment_date" placeholder="Payment Date">
      <input type="number" v-model="editableDividend.annual_dividend" placeholder="Annual Dividend">
      <label>
        <input type="checkbox" v-model="editableDividend.isPaid"> Is Paid
      </label>
      <button @click="isEditingDividend ? updateDividend() : addNewDividend()">Save</button>
      <button @click="resetForm()">Cancel</button>
    </div>
    <!-- Display Dividend Holdings -->
    <table>
      <thead>
        <tr>
          <th>Symbol</th>
          <th>Quantity</th>
          <th>Dividend Amount</th>
          <th>Ex-Dividend Date</th>
          <th>Payment Date</th>
          <th>Annual Dividend</th>
          <th>Paid</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
  <tr v-for="dividend in dividends" :key="dividend.id">
    <td data-label="Symbol">{{ dividend.div_symbol }}</td>
    <td data-label="Quantity">{{ dividend.quantity }}</td>
    <td data-label="Amount">{{ dividend.dividend_amount }}</td>
    <td data-label="Ex-Date">{{ formatDate(dividend.ex_dividend_date) }}</td>
    <td data-label="Pmt-Date">{{ formatDate(dividend.payment_date) }}</td>
    <td data-label="Annual %">{{ dividend.annual_dividend }}</td>
    <td data-label="Paid">{{ dividend.is_paid }}</td>
    <td data-label="Actions">
      <button @click="editDividend(dividend)">Edit</button>
      <button @click="deleteDividend(dividend.id)">Delete</button>
    </td>
  </tr>
</tbody>
    </table>    <button @click="showDividendForm = true">Add Dividend</button>
  </div></div>
</template>
<script>
import { Auth } from 'aws-amplify';

export default {
  data() {
    return {
      dividends: [],
      showDividendForm: false,
      isEditingDividend: false,
      editableDividend: {
        div_symbol: '',
        quantity: '',
        dividend_amount: '',
        ex_dividend_date: '',
        payment_date: '',
        annual_dividend: '',
        isPaid: false
      }
    };
  },

  methods: {
    formatDate(date) {
      return date ? new Date(date).toISOString().substring(0, 10) : '';
    },

    resetForm() {
      this.editableDividend = {
        div_symbol: '',
        quantity: '',
        dividend_amount: '',
        exDividendDate: '',
        paymentDate: '',
        annualDividend: '',
        isPaid: false
      };
      this.showDividendForm = false;
      this.isEditingDividend = false;
    },
    getNewDividend() {
      return {
        div_symbol: '',
        quantity: '',
        dividend_amount: '',
        exDividendDate: '',
        paymentDate: '',
        annualDividend: ''
      };
    },
    async addNewDividend() {
      const dividendData = {...this.editableDividend};
      // Handle date and number formatting
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        await fetch('https://api.riskypaws.com/frontoffice/api/dividend/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Cognito-Sub': cognitoSub
          },
          body: JSON.stringify(dividendData)
        });
        this.resetDividendForm();
        this.fetchDividends();
      } catch (error) {
        console.error('Error adding new dividend:', error);
      }
    },
    async fetchDividends() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const response = await fetch('https://api.riskypaws.com/frontoffice/api/dividend/', {
          headers: { 'X-Cognito-Sub': cognitoSub }
        });
        if (!response.ok) throw new Error('Network response was not ok');
        this.dividends = await response.json();
      } catch (error) {
        console.error('Error fetching dividends:', error);
      }
    },
    editDividend(dividend) {
      this.editableDividend = {...dividend};
      this.isEditingDividend = true;
    },
    async updateDividend() {
      const dividendData = {...this.editableDividend};
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        await fetch(`https://api.riskypaws.com/frontoffice/api/dividend/${dividendData.id}/`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-Cognito-Sub': cognitoSub
          },
          body: JSON.stringify(dividendData)
        });
        this.resetDividendForm();
        this.fetchDividends();
      } catch (error) {
        console.error('Error updating dividend:', error);
      }
    },
    async deleteDividend(dividendId) {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        await fetch(`https://api.riskypaws.com/frontoffice/api/dividend/${dividendId}/`, {
          method: 'DELETE',
          headers: { 'X-Cognito-Sub': cognitoSub }
        });
        this.fetchDividends();
      } catch (error) {
        console.error('Error deleting dividend:', error);
      }
    },
    cancelEdit() {
      this.resetDividendForm();
    },
    resetDividendForm() {
      this.editableDividend = this.getNewDividend();
      this.isEditingDividend = false;
    }
  },
  created() {
    this.fetchDividends();
  }
};
</script>
  
        
    <style scoped>
  
    
    .financial-health {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    }
    
    .scores-container {
      display: flex;
      flex-wrap: wrap; /* Allows items to move to the next row on smaller screens */
      justify-content: center; /* Centers items */
      align-items: center;
      width: 100%;
      border: 2px solid #000;
      border-radius: 10px;
      padding: 20px;
      box-sizing: border-box;
      background-color: #C9B6D9; 
    }
    
    .score-item {
      flex: 1 1 18%; /* Adjust this value to fit 5 items in a row */
      text-align: center;
      margin: 10px; /* Adds some space around each item */
      min-width: 180px; /* Minimum width for each item */
      /* ... */
    }
    
    .score-icon {
    transition: color 0.3s ease-in-out;
    font-size: 30px;
    }
    
    .score-icon:hover {
    color: red;
    }
    
    .icon-title-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    }
    
    .title {
    margin-top: 10px; /* Optional: Adjusts space between icon and title */
    }
    
    .score {
    margin-top: 10px; /* Optional: Adjusts space between title and score */
    }
    @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
    }
    
    .score-icon:hover {
    animation: bounce 0.5s ease-in-out infinite;
    }
    
    .card, .card-body
    {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    padding: 20px;
    text-align: center;
    }
    
    .card:hover {
    transform: translateY(-10px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
    
    .icon-title-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
    }
    
    .score {
    font-size: 1.2em;
    font-weight: bold;
    }
    
    .scores-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    border: 2px solid #4A148C;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    background-color: white; 
    flex-direction: row;
    flex-wrap: wrap;  /* Allows items to move to the next row on smaller screens */
    justify-content: space-around;
    }
    
    .score-item {
    flex: 1 1 auto;  /* Allows items to grow and shrink */
    text-align: center;
    margin: 10px;  /* Adds some space around each item */
    /* ... */
    }
    .score-item .fa-heart:hover {
    color: red; /* Color for Financial Health */
    }
    
    .score-item .fa-grin-beam:hover {
    color: yellow; /* Color for Financial Happiness */
    }
    
    .score-item .fa-dollar-sign:hover {
    color: green; /* Color for Financial Wealth */
    }
    
    .score-item .fa-water:hover {
    color: blue; /* Color for Financial Liquidity */
    }
    
    .score-item .fa-book:hover {
    color: purple; /* Color for Financial Education */
    }
    .risk-score-card {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px;
    margin-bottom: 20px;
    background-color: #36454f;
    color: white;
    font-size: 24px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }
    
    .risk-icon {
    margin-right: 10px;
    font-size: 30px;
    }
    
    
    
    button {
    background-color: #4A148C; /* Purple background */
    color: white; /* White text */
    border: none;
    border-radius: 20px; /* Rounded corners */
    padding: 10px 20px; /* Padding inside the button */
    cursor: pointer; /* Cursor style */
    transition: background-color 0.3s ease; /* Smooth transition for hover effect */
  }
  
  button:hover {
    background-color: black; /* Black background on hover */
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
  }
  
  th, td {
    border: 1px solid #4A148C;
    padding: 8px;
    text-align: left;
  }
  
  th {
    background-color: #f4f4f4;
  }
  
  .positive-gain {
    color: green;
  }
  
  .negative-loss {
    color: red;
  }
  .dividend-tracker table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }

  .dividend-tracker th, .dividend-tracker td {
    border: 1px solid #4A148C;
    padding: 8px;
    text-align: left;
  }

  .dividend-tracker th {
    background-color: #f4f4f4;
    color: #333;
  }

  /* Responsive table for mobile */
  @media screen and (max-width: 768px) {
    .dividend-tracker table, 
    .dividend-tracker thead, 
    .dividend-tracker tbody, 
    .dividend-tracker tr {
      display: block;
    }

    .dividend-tracker th {
      display: none; /* Hide table headers */
    }

    .dividend-tracker td {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid #ddd;
    }

    .dividend-tracker td:before {
      content: attr(data-label);
      font-weight: bold;
      flex-basis: 40%;
    }

    .dividend-tracker td[data-label="Actions"] button {
      flex-grow: 1;
    }
  }


    </style>